import {undoPendingDeletion, usePendingLifeStoryDeletion} from './lifeStoryPendingDeletion'
import {useNotificationContext} from '../../../../../shared_components/notifications/NotificationContext'

import './lifeStory.scss'

/**
 * The mock's undo snackbar: appears after a life story is deleted (review
 * kebab) or a draft is discarded (hero dismiss) for as long as the deletion
 * can still be taken back. Renders nothing otherwise, so it mounts cheaply
 * wherever those flows can land.
 */
const LifeStoryUndoBar = () => {
  const pendingDeletion = usePendingLifeStoryDeletion()
  const {alwaysNotify} = useNotificationContext()

  if (!pendingDeletion || pendingDeletion.committing)
    return null

  // The undo window can close between render and click (the deletion started
  // committing); only celebrate when the cancellation actually landed.
  const undo = () => {
    if (undoPendingDeletion())
      alwaysNotify.shortSuccess('Restored \u2014 your story is back.')
    else
      alwaysNotify.shortError('Too late to undo \u2014 the deletion had already started.')
  }

  return (
    <div aria-live='polite' className='ls-undo-bar' role='status'>
      <span>{pendingDeletion.message}</span>
      <button onClick={undo}>Undo</button>
    </div>
  )
}

export default LifeStoryUndoBar
